import { defaultMeta } from '@/constants/defaultMeta';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { affiliateLogQueries } from '@/services/payment/affiliate/affiliate.queries';
import { useSearch } from '@tanstack/react-router';

export const useGetAffiliateLog = () => {
  const search = useSearch({ from: '/(app)/payment-management/affiliate-log/' });

  const { data, isFetched, isLoading } = useQuery({
    ...affiliateLogQueries.list(),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, search.sort),
    }),
  });

  return {
    affiliateData: data?.data || [],
    isFetched,
    isLoading,
    pagination: defaultMeta,
  };
};

export default useGetAffiliateLog;
